<template lang="pug">
  footer
    #auth(v-if="isAuthenticated && member")
      component.customer(
        :is="memberComponent.is"
        v-bind="memberComponent.props"
      ) {{ member.company || member.name }}
    Menu#footer-menu(k="footer-menu" :max-depth="1")
    .some-links
        router-link.button.is-outlined.is-small(:to="{ name: 'order-check' }") Ordercheck
    BudgetingTool(v-if="isAuthenticated && member && shopID === 14")
</template>

<script>
import { mapGetters } from 'vuex';

import Menu from '@/components/Menu.vue';
import BudgetingTool from '@/extensions/shop/components/BudgetingTool';

import { get } from '@/helpers';

export default {
    name: 'Footer',
    components: {
        Menu,
        BudgetingTool
    },
    computed: {
        userFormRoute() {
            let path;
            this.menus.forEach(menu => {
                const item = menu.menuItems.find(item => get(item, 'page.view') === 'UserForm');
                if (item && item.path && !path) {
                    path = item.path;
                    return;
                }
            });
            return path;
        },
        memberComponent() {
            let memberComponent = {
                is: 'span',
                props: {}
            };
            if (this.userFormRoute) {
                memberComponent.is = 'router-link';
                memberComponent.props.to = this.userFormRoute;
            }
            return memberComponent;
        },
        shopID() {
            return parseInt(get(this.CMS, 'shop.id', false));
        },
        ...mapGetters({
            member: 'auth/member',
            isAuthenticated: 'auth/isAuthenticated',
            menus: 'menus',
            config: 'config',
            CMS: 'CMS'
        })
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply hidden
  @screen lg
    @apply flex
    justify-content: flex-start
    position: fixed
    bottom: 0
    color: #fff
    background: $color-adenauer-orange !important
    backdrop-filter: blur(30px)
    width: 100%
    z-index: 999
    height: $footerHeight
    #auth
      padding-left: 3rem
    nav#footer-menu
      flex-grow: 1
      justify-content: flex-start
      padding-left: 3rem
    .some-links
      display: flex
      align-items: center
  #auth .customer
    line-height: 36px
    font-weight: bold
  ::v-deep
    .budgeting-tool
      margin-right: 3rem
  #auth,
  nav#footer-menu
    // @apply mx-auto p-4 hidden
    display: none
    height: 100%
    align-items: center
    position: relative
    @screen lg
      display: flex
    ::v-deep
      ul
        & > li
          border: 0
          display: inline-block
          & + li
            &:before
              content: "/"
              margin: 0 2px
          &.active .tree-item a
            // background: var(--color-primary)
            // --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
            // color: hsl(0, 0%, var(--switch))
          .tree-item
            display: inline-block
            a
              line-height: 1
              padding: 2px 5px 4px
</style>
